module.exports = __webpack_public_path__ + "img/no-acl.f55bafa5.svg";